import { Link } from "react-router-dom";
import { PAGES } from "../../routeConfig";
import { OwlCarousel as ReactOwlCarousel } from "../../Layout/Common/owlCarousel";
import { useContext, useEffect, useRef, useState } from "react";
import { isValidArray } from "../../Layout/Common/common";
import { GlobalContext } from "../../Context/GlobalContext";
import { useGlobalFunction } from "../../Context/GlobalFunctionContext";

export const CategoryContainer = () => {
  const { categorySlider, setCategorySlider } = useContext(GlobalContext);
  const { fetchCategorySliderData } = useGlobalFunction();
  const [categoryData, setCategoryData] = useState(null);

  useEffect(() => {
    fetchCategorySliderData();
  }, []);
  useEffect(() => {
    if (isValidArray(categorySlider)) {
      const sortedCategorySlider = categorySlider?.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, {
          sensitivity: "base",
        }),
      );
      setCategoryData(sortedCategorySlider);
    }
  }, [categorySlider]);

  const options = {
    loop: false,
    margin: 40,
    nav: false,
    dots: false,
    responsive: {
      0: { items: 2 },
      400: { items: 3 },
      600: { items: 4 },
      800: { items: 5 },
      1000: { items: 6 },
    },
  };
  const owlRef = useRef();

  const goPrev = () => {
    owlRef.current.prev();
  };

  const goNext = () => {
    owlRef.current.next();
  };
  return (
    <section className="category-section section-padding">
      <div className="container-fluid container-lg">
        <div className="row">
          <div className="col-md-12">
            {/* section-title */}
            <div className="section-title">
              <h2>Category</h2>
              <Link to={PAGES.CATEGORY} className="text-decoration-underline text-uppercase">
                View All
              </Link>
            </div>
            {/* section-title */}
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="category-carousel-wrapper position-relative">
              <div className="homeCustom-nav category-left-arrow" onClick={goPrev}>
                <i className="fa-solid fa-angle-left" />
              </div>
              <ReactOwlCarousel
                ref={owlRef}
                className="owl-carousel category-carousel homepage-owlCarousel position-relative"
                {...options}
              >
                {isValidArray(categoryData) &&
                  categoryData.map((item, index) => (
                    <div className="item text-center" key={index}>
                      <Link to={item.link} className="text-center">
                        <img src={item.image} alt={item.alt} className="text-center mx-auto" />
                      </Link>

                      <Link to={item.link} className="text-center">
                        {item.name}
                      </Link>
                    </div>
                  ))}
              </ReactOwlCarousel>
              <div className="homeCustom-nav category-right-arrow" onClick={goNext}>
                <i className="fa-solid fa-angle-right" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
